     <div class="table">
      <div class="table_container">
      <table mat-table [dataSource]="dataSource">
        <!--- Note that these columns can be defined in any order.
                    The actual rendered columns are set as a property on the row definition" -->
  
       <!--  status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Note Status</th>
          <td mat-cell *matCellDef="let element">
            {{ element?.status }}
          </td>
        </ng-container>
  
           <!-- Assigned Column -->
           <ng-container matColumnDef="assigned">
            <th mat-header-cell *matHeaderCellDef>Assigned</th>
            <td mat-cell *matCellDef="let element">
                {{ commonService.getFullName(element?.assigned?.firstName, element?.assigned?.lastName) }}
    
          </ng-container>
  
  
           <!-- Agreement Number -->
        <ng-container matColumnDef="agreementNumber">
          <th mat-header-cell *matHeaderCellDef>Agreement Number</th>
          <td mat-cell *matCellDef="let element">
            {{ element?.agreementNumber }}
          </td>
        </ng-container>
  
        <!-- createdOn Column -->
        <ng-container matColumnDef="createdOn">
          <th mat-header-cell *matHeaderCellDef>Created on</th>
          <td mat-cell *matCellDef="let element">
            {{ commonService.convertDate( element?.createdOn) | date : "MMM-dd-YYYY h:mm a" }}
          </td>
        </ng-container>

            <!-- updatedOn Column -->
            <ng-container matColumnDef="updatedOn">
              <th mat-header-cell *matHeaderCellDef>Updated on</th>
              <td mat-cell *matCellDef="let element">
                {{ commonService.convertDate( element?.createdOn) | date : "MMM-dd-YYYY h:mm a" }}
              </td>
            </ng-container>
  
             <!-- createdBy Column -->
             <ng-container matColumnDef="createdBy">
              <th mat-header-cell *matHeaderCellDef>Created By</th>
              <td mat-cell *matCellDef="let element">
                {{ commonService.getFullName(element?.createdBy?.firstName, element?.createdBy?.lastName) }}
              </td>
            </ng-container>

             <!-- createdBy Column -->
             <ng-container matColumnDef="updatedBy">
              <th mat-header-cell *matHeaderCellDef>Updated By</th>
              <td mat-cell *matCellDef="let element">
                {{ commonService.getFullName(element?.createdBy?.firstName, element?.createdBy?.lastName) }}
              </td>
            </ng-container>
  
              <!-- Priority Column -->
              <ng-container matColumnDef="priority">
                <th mat-header-cell *matHeaderCellDef>Priority</th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.priority }}
                </td>
              </ng-container>
              <ng-container matColumnDef="fileClaimNumber">
                <th mat-header-cell *matHeaderCellDef>Claim Number</th>
                <td mat-cell *matCellDef="let element">
                  {{ element?.claimDetails?.fileClaimNumber }}
                </td>
              </ng-container>
  
                  <!-- notes Column -->
                  <ng-container matColumnDef="notes">
                    <th mat-header-cell *matHeaderCellDef>Request</th>
                    <td mat-cell *matCellDef="let element">
                      <div class="maxTxt">
                        {{ element?.notes}}
                        
                      </div>
                      
                    </td>
                  </ng-container>
      
  
        <ng-container matColumnDef="actions" stickyEnd>
          <th *matHeaderCellDef class="actions-cell" mat-header-cell>Actions</th>
          <td *matCellDef="let row; let i = index" class="actions-cell" mat-cell>
            <button
              type="button"
              mat-icon-button
              [matMenuTriggerFor]="actionsMenu"
              (click)="$event.stopPropagation()"
            >
              <mat-icon>more_horiz</mat-icon>
            </button>
            <mat-menu #actionsMenu="matMenu" yPosition="below" xPosition="before">
              <button mat-menu-item (click)="handleNotes('update', row)">
                <span>Edit</span>
              </button>
              <button mat-menu-item (click)="handleNotes('view', row)">
                <span>View</span>
              </button>
            </mat-menu>
          </td>
        </ng-container>
  
        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
      <div
        *ngIf="dataSource?.length === 0"
        style="padding: 10px 0; text-align: center"
      >
        No data found.
      </div>
      </div>
    </div>
  